import { FC } from "react";

interface StepHeadingProps {
  step: number;
  title: string;
  description: string;
}

const StepHeading: FC<StepHeadingProps> = ({ description, step, title }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full gap-4 ">
      <span className="bg-color-primary text-white rounded-full w-8 h-8 flex items-center justify-center my-2">
        {step}
      </span>

      <h3 className="text-color-primary font-semibold text-[18px] ">{title}</h3>
      <p className="text-color-sec-title text-center text-[14px]">
        {description}
      </p>
    </div>
  );
};

export default StepHeading;
